export default __webpack_public_path__ + "static/media/8169-mala.97cf29f4.pdf";